import { addFullscreenExitCallback, getParameterByName, isObject } from "@helpers/utils.js"
import { reactive, nextTick } from "vue"
import controller from "./controller/controller.js";

import model from "./model.js";
import Enum from "@shared/enum.js";
import NetworkError from "@components/network-error-view.vue";
import UpperNotification from "@components/upper-notification-view.vue";
import modalHeaderTemplate from "@components/modal/modal-header-template.vue";
import { scrollTop } from "@helpers/dom.js";
import dynamicImportLoad from "@helpers/dynamic-import-load.js";

export default {
	components: { NetworkError, UpperNotification, modalHeaderTemplate },
	created(){
		model.vue.root = this;

		document.addEventListener('scroll', () => this.scrollPosObs = scrollTop());

		addFullscreenExitCallback(fsActive => this.inFS = fsActive);

		updateCurrCatIDs.call(this);
		model.on('CurrCatIDs', () => updateCurrCatIDs.call(this));

		function updateCurrCatIDs(){
			Object.keys(model.currCatIds).forEach(propName => {
				this.currCatIds[propName] = model.currCatIds[propName];
			});
		}
			
		model.on('NetworkError', () => this.networkErrDisplayed = model.networkError);

		!model.isMobile && model.on('WindowResize', (e) => {
			var isMobileMode = window.innerWidth < 1024;
			this.mobileMode = isMobileMode;
			!isMobileMode && model.dispatchEvent('HideMobileNav');
		});

		model.on('LoginComplete', 'LogoutComplete', async () => {
			await controller.onInitialized();

			this.siteId = model.siteId;
			if (getParameterByName('avoidnavstatuschange') != 'true') {
				this.userAuthStatus = Enum.UserAuthStatuses[model.logged ? 'LOGIN' : 'LOGOUT'];
			}
			this.userLogged = model.logged;
			this.userValidated = model.userValid();
			this.userActive = model.userActive();
			this.renderValidationUI = getParameterByName('validreqtest') == 'true' || (model.userActive() && !model.accDisabled() || model.notValidByReasonStatusId());
			for (var key in this.supportInfo) this.supportInfo[key] = model.supportInfo[key];
			this.userProductId = Boolean(model.userProfile) && model.userProfile.productId;
		});

		model.on('GetPlayerInfoLoaded', 'UserProfileLoaded', 'SetLang', 'LogoutComplete', (e) => {
			this.userCurrency = (model.getCurrency());
			this.uiType = (model.uiType);
			this.userProfile = (model.userProfile || {});
			model.observables.userCountry = model.userProfile?.country;
		});

		var onSetLang = () => {
			this.lang = model.lang;
			this.langKey = model.langKey;
			this.language = model.language;
		}

		onSetLang();
		model.on('SetLang', onSetLang);

		(() => {
			let preloadTimeout;

			this.preloaderDisplayed = shouldBeDisplayed.call(this);
			let delayedPreloader = 0;

			model.on('ShowPreloader', () => {
				delayedPreloader += model.pendingScripts + model.globalRequests;
				clearTimeout(preloadTimeout);
				this.preloaderDisplayed = shouldBeDisplayed.call(this);
			});

			model.on('HidePreloader', () => {
				clearTimeout(preloadTimeout);
				preloadTimeout = setTimeout(() => {
					if(shouldBeDisplayed.call(this)) return;
					this.preloaderDisplayed = false;
					delayedPreloader = 0;
				}, delayedPreloader > 0 ? 500 : 100);
			});

			function shouldBeDisplayed(){
				if(model.observables.selectedMiniGame) return false;

				return (
					model.workerRequests > 0 ||
					model.globalRequests > 0 || 
					model.pendingScripts > 0 || 
					model.dynamicImports > 0
				)
			}
		})();

		model.on('OpenPage', () => model.observables.activePage = model.observables.activePage);
		model.on('MobileSideMenuActive', props => this.mobileSideMenuActive = props.active);

		this.$watch(() => this.backdropContentVisible, bool => {
			model.dispatchEvent('BackdropContentVisible', 'ForceResize', {bool});
		});

		(() => {
			if(!model.isMobile) return;

			let scrollTopBefore = 0;

			model.on('BackdropContentVisible', e => {
				if (!e.bool) {
					scrollTopBefore = scrollTop();
					return;
				}

				nextTick(() => scrollTop(scrollTopBefore));
			});
		})();
	},
	data(){
		return {
			appViewInfo: model.compInfo,
			modalDisplayed: false,
			limitsFormIncluded: model.limitsFormIncluded,
			hasProviderName: Boolean(model.thProviderName),
			spaceBusAmounts: model.spaceBusAmounts,
			hideCMGameLoad: model.hideCMGameLoad,
			view: model.view,
			UIID: model.UIID,
			siteId: model.siteId,
			uiType: model.uiType,
			isMobile: model.isMobile,
			isIOS: model.isIOS,
			filterActive: model.filterActive,
			maxScreenHeight: `${model.maxScreenHeight}px`,
			activePage: model.observables.activePage,
			mobileMode: model.isMobile,
			userCurrency: model.getCurrency(),
			currCatIds: {},
			supportInfo: (supportInfo => {
				var obj = {};
				for (var key in supportInfo)
					obj[key] = supportInfo[key];
				return obj;
			})(model.supportInfo),
			modals: controller.registeredModals.value,
			fixedTop: {value: 0},
			preloaderDisplayed: false,
			userValidated: false,
			userActive: false,
			renderValidationUI: false,
			userProductId: false,
			userLogged: false,
			userAuthStatus: Enum.UserAuthStatuses.UNDETERMINED,
			lang: '',
			langKey: '',
			language: '',
			networkErrDisplayed: false,
			mobileSideMenuActive: false,
			inFS: false,
			userProfile: {},
			modalVisible: false,
			gameDisplayed: false,
			filterDisplayed: false,
			anyBannerPages: false,
			scrollPosObs: 0,
		};
	},
	computed: {
		backdropContentVisible() {
			var modalVisible = this.modalDisplayed;
			var gameDisplayed = model.observables.gameDisplayedObs;
			var filterDisplayed = model.observables.filterDisplayed;

			if (model.isMobile) return !modalVisible && !filterDisplayed && !gameDisplayed;
			return !gameDisplayed;
		},
		firstDepCompleted () {
			return model.observables.deposits > 0;
		},
	},
	methods: {
		hasPromoStarted(){
			return EGOE.hasPromoStarted.apply(this, arguments);
		},
		updatePaddingTop(extraHeight) {
			if(typeof extraHeight !== 'number') extraHeight = 0;

			function deductAppAdvert(){
				let headerAdvert = document.querySelector('.app-advert.on-header');
				return (model.vue.root.fixedTop.value - (headerAdvert ? headerAdvert.offsetHeight : 0) + 'px');
			}

			if (model.isUI('FOUR_SG') || model.isUI('SKY')) {
				if(model.isApp){
					if(model.observables.activePage === Enum.Pages.LOBBY) return '0px';
					return model.vue.root.fixedTop.value + 'px';
				}

				return model.vue.root.fixedTop.value + extraHeight + 'px';
			}

			if (model.isUI('FUND')) {
				if(model.isMobile && model.observables.filterDisplayed){
					return (model.vue.root.fixedTop.value + 80) + 'px';
				}

				if(model.appAdvert){
					if(model.observables.activePage === Enum.Pages.WEBRES){
						if(model.observables.subNavPlaceholderSlim) return deductAppAdvert();
					}
					else if(model.observables.activePage === Enum.Pages.PROMO_INFO || model.isView(Enum.Views.CRM)) return deductAppAdvert();
				}

				if(model.observables.subNavPlaceholderSlim && !model.observables.filterDisplayed) return '0px';

				if(model.isView(Enum.Views.MANIFIESTO)) return (model.vue.root.fixedTop.value + 'px');

				return ![
					Enum.Pages.MAINHOME,
					Enum.Pages.PROMO_INFO,
					Enum.Pages.PAGE_NOT_FOUND,
				].includes(model.observables.activePage) ? (model.vue.root.fixedTop.value + 'px') : 0;
			}

			return null;
		},
		debug(arg){
			console.log(arg);
		},
		createLangObs(comp, obj, forceAsObj) {
			if (typeof forceAsObj !== 'boolean')
				forceAsObj = false;

			var isObj = forceAsObj || isObject(obj);

			let obs = reactive({value: null});
			obs.value = isObj ? model.redeemLangObj(obj) : model.getStr(obj);

			nextTick(() => {
				let cbx = model.on('SetLang', () => {
					obs.value = (isObj ? model.redeemLangObj(obj) : model.getStr(obj))
				});
			});

			return obs;
		},
		changeExtToWebP(img) {
			return controller.changeExtToWebP(img);
		},
		checkUserAuthStatus(status) {
			return this.userAuthStatus == status;
		},
		goTo(uiContext, removePrevModals) {
			model.observables.userInteracted = true;
			return controller.goTo(uiContext, removePrevModals);
		},
		gotoCategory(ids) {
			return controller.gotoCategory(ids);
		},
		goToPromo(uiContext) {
			return controller.loadPromoWin(uiContext);
		},
		getCurrency(code) {
			return model.currencies[('' + code).toUpperCase()] || {};
		},
		getStr(label) {
			return model.getStr(label);
		},
		formatAsCurrency(params) {
			return model.formatAsCurrency(params);
		},
		openFooterLink(id, label) {
			return () => {
				controller.openFooterLink(id, label);
			};
		},
		startGame(gameID) {
			controller.startGame({
				gameID: gameID,
				mode: 'fun',
			});
		},
		displayHtmlContent(title, htmlContent) {
			return controller.displayHtmlContent(title, htmlContent);
		},
		isUI() {
			return model.isUI.apply(model, arguments);
		},
	},
}